import React from 'react';
import {UploadDataPoint} from "../_section/DataPointForm";

function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>
            {/*<UploadDataPoint setMortgage={setMortgage} name="documentDate" upload={upload} inExtWindow={inExtWindow}/>*/}
            <UploadDataPoint setMortgage={setMortgage} name="customerNames" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="propertyAddress" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="sumInsured" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="bankName" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="startDate" upload={upload} inExtWindow={inExtWindow}/>
            {/*<UploadDataPoint setMortgage={setMortgage} name="developerName" upload={upload} inExtWindow={inExtWindow}/>*/}
        </>
    );


}


export default DataForm;